export default {
  auth: () => import("/vercel/path0/layouts/auth.vue"),
  "guest-app": () => import("/vercel/path0/layouts/guest-app.vue"),
  main: () => import("/vercel/path0/layouts/main.vue"),
  page: () => import("/vercel/path0/layouts/page.vue"),
  quote: () => import("/vercel/path0/layouts/quote.vue")
}